import { useFadeIn } from '@/hooks/useFadeIn';

export default function IconCta() {
  const heading = useFadeIn({ direction: 'up' });
  const buttons = useFadeIn({ direction: 'up', delay: 200 });
  const note = useFadeIn({ direction: 'up', delay: 400 });

  return (
    <section className="py-20 md:py-32" style={{ backgroundColor: '#3E5F8F' }}>
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div ref={heading.ref} style={heading.style}>
          <div className="w-10 h-px bg-white/30 mx-auto mb-6"></div>
          <span className="inline-block text-white/60 font-light text-xs md:text-sm tracking-[0.2em]">
            ご相談・ご予約
          </span>
          <h2 className="font-serif text-white text-2xl md:text-3xl lg:text-4xl leading-relaxed mt-6 mb-6">
            まずは、ご相談から。
          </h2>
          <p className="font-light text-white/65 text-sm md:text-base leading-loose max-w-xl mx-auto">
            「自分の白い点はICONで改善できる?」<br />
            そのご質問から始められます。<br />
            カウンセリングで口腔内を確認した上で、<br />
            最適な治療プランと費用をご提案します。
          </p>
        </div>

        <div
          ref={buttons.ref}
          style={buttons.style}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10"
        >
          <a
            href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-white font-medium text-sm px-8 py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-gray-100 transition-colors duration-200"
            style={{ color: '#3E5F8F' }}
          >
            無料カウンセリングを予約する
          </a>
          <a
            href="tel:050-1809-4594"
            className="inline-flex items-center justify-center bg-transparent text-white font-medium text-sm px-8 py-4 rounded-full border border-white/30 whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors duration-200"
          >
            050-1809-4594
          </a>
        </div>

        <div ref={note.ref} style={note.style} className="mt-6">
          <p className="font-light text-white/40 text-xs tracking-wide">
            診療時間 10:00〜19:00 / 月曜・祝日休診
          </p>
        </div>
      </div>
    </section>
  );
}